var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.002,
    height: 125.373,
    viewBox: "0 0 150.002 125.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42666",
    "data-name": "Group 42666",
    transform: "translate(-400.996 -584.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M7232.86,22673.508c-1.383-1.115-2.771-2.219-4.148-3.322-2.925-2.344-5.958-4.77-8.917-7.158q-4.37-3.551-8.764-7.074c-7.631-6.145-15.523-12.5-23.177-18.9-9.407-7.869-16.11-15.1-21.072-22.738a44.909,44.909,0,0,1-7.54-20.281c-.005-.051-.051-.205-.08-.312-.04-.125-.074-.246-.108-.377l-.057-.215v-6.955l.211-1.178c.119-.729.25-1.463.37-2.186a39.71,39.71,0,0,1,14.363-24.947,40.968,40.968,0,0,1,39.515-6.367c8.217,3.016,14.943,8.684,20.542,17.3.068-.107.137-.205.211-.312,8.655-12.889,20.1-19.422,34.006-19.422a48.321,48.321,0,0,1,4.985.262,39.5,39.5,0,0,1,34.331,29.426c.444,1.668.74,3.363,1.03,5,.131.734.262,1.49.4,2.225l.034.178v6.936l-.04.182c-.182.883-.347,1.8-.518,2.682a56.531,56.531,0,0,1-1.377,6.094c-2.14,7.08-6.2,13.852-12.781,21.316-7.7,8.736-16.5,16.037-24.851,22.768-7.921,6.379-16.007,12.828-23.826,19.064q-4.934,3.935-9.873,7.875c-.148.119-.3.229-.472.354l-1.32.949Z",
    transform: "translate(-6758.001 -21964.688)",
    fill: "#fffbf5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillHeart);
export default __webpack_public_path__ + "static/media/Fill_Heart.aa467c475e105423a5a9c57ea79092cb.svg";
export { ForwardRef as ReactComponent };